<template>
  <b-container>
    <b-row>
      <b-col class="mt-3 text-center">
        <h3>TRANSPORT SCANNER</h3>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col cols="8" class="text-center">
        <b-form-input
          class="bg-dark text-white border-dark focus:outline-none"
          style="text-align: center"
          lang="en"
          ref="qr"
          v-model="code"
          v-on:keyup.enter="scan"
          placeholder="SCAN QR CODE">
        </b-form-input>
      </b-col>
      <b-col cols="2" class="rounded">
        <b-button class="btn-dark p-2 w-100">COUNT: {{this.totalCount}}</b-button>
      </b-col>
      <b-col cols="2" class="rounded">
        <b-button class="btn-dark p-2 w-100">{{this.totalPrice.toFixed(2).toLocaleString('en')}} PLN</b-button>
      </b-col>
    </b-row>
    <b-row v-if="list.length" class="mt-3 px-3">
      <table class="table no-hover" ref="articles">
        <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">ORDER</th>
          <th class="text-center" scope="col">COUNT</th>
          <th scope="col">PLN</th>
          <th scope="col">PACKED</th>
          <th class="text-center" scope="col">SENT</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(row, i) of list" :key="i" :class="getClassForMetadata(row.products[0])">
          <td>{{i+1}}</td>
          <td>{{row.order.metaData}}</td>
          <td class="text-center">{{getPackedCount(row.products)}}</td>
          <td>{{getPackedValue(row.products).toFixed(2).toLocaleString('en')}}</td>
          <td>{{moment(row.order.packedAt).format('DD.MM.yyyy')}}</td>
          <td class="text-center">{{moment(row.products[0].transport.poland).format('DD.MM.yyyy')}}</td>
        </tr>
        </tbody>
      </table>
    </b-row>
<!--    <p>{{JSON.stringify(list)}}</p>-->
  </b-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import fixed from '@/fixed';
import { metadataMapping } from '@/utils';

export default {
  data: () => ({
    list: [],
    code: '',
    ticker: null,
    totalPrice: 0,
    totalCount: 0,
    successAudio: null,
    errorAudio: null,

    moment,
  }),
  async mounted() {
    // autofocus scanner input
    // this.ticker = setInterval(() => {
    //   this.$refs.qr.focus();
    // }, 900);
    this.$refs.qr.focus();
    // get packages in transport
    await this.getInTransport();
    // preload scan sounds
    this.successAudio = new Audio('/ok.mp3');
    this.errorAudio = new Audio('/error.mp3');
  },
  beforeDestroy() {
    if (this.ticker) clearInterval(this.ticker);
  },
  methods: {
    async getInTransport() {
      try {
        const { data } = await axios.get(`${fixed.API_URL}/in-transport`, { withCredentials: true });
        this.list = data || [];
        await this.getInTransportValue(this.list);
      } catch (error) {
        this.$toast.error(error.response.data || 'can\'t get the transport list');
      }
    },
    async scan() {
      if (!this.code) return;
      try {
        await axios.put(`${fixed.API_URL}/transport-scan/${this.code}`, {}, { withCredentials: true });
        this.$toast.success('box scanned successfully');
        this.playSound('ok');
        // get updated list after the scan
        await this.getInTransport();
      } catch (error) {
        this.$toast.error(error.response.data || 'error while scanning, contact support');
        this.playSound('error');
      }
      // reset the code input after the scan
      this.code = '';
    },
    playSound(type) {
      if (type === 'ok' && this.successAudio) {
        this.successAudio.currentTime = 0; // Reset to start
        this.successAudio.play();
      } else if (type === 'error' && this.errorAudio) {
        this.errorAudio.currentTime = 0;
        this.errorAudio.play();
      }
    },
    getClassForMetadata(order) {
      if (order.orderedFor) return 'bg-dark';
      const mapped = metadataMapping.find((m) => m.pattern.test(order.metaData));
      return mapped.getClass(order?.deliveryMethod?.name);
    },
    getPackedCount(order) {
      return order.reduce((acc, item) => item.noteType !== 2 ? acc + item.count : acc, 0); // eslint-disable-line
    },
    getPackedValue(order) {
      return order.reduce((acc, item) => item.noteType !== 2 ? acc + (item.price * item.count) : acc, 0); // eslint-disable-line
    },
    getInTransportValue(orders) {
      this.totalPrice = 0;
      this.totalCount = 0;
      if (orders.length) {
        orders.forEach((order) => {
          order.products.forEach((product) => {
            this.totalPrice += (product.price * product.count);
            this.totalCount += product.count;
          });
        });
      }
    },

  },
};
</script>

<style>
.regos-tape {
  background: #fada08 !important;
  color: #222222;
}
.pickup-location {
  background: #f8f9fa !important;
  color: #222222;
}
</style>
